import { render, staticRenderFns } from "./BreakTab.vue?vue&type=template&id=1466d6a0&scoped=true"
import script from "./BreakTab.vue?vue&type=script&lang=js"
export * from "./BreakTab.vue?vue&type=script&lang=js"
import style0 from "./BreakTab.vue?vue&type=style&index=0&id=1466d6a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1466d6a0",
  null
  
)

export default component.exports